import angular from "angular";

angular
    .module('app')
    .component('courseChaptersModal', {
        template: require('./course-chapters-modal.html'),
        controller: [controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller() {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.course = $ctrl.resolve.course;
        $ctrl.lesson = $ctrl.resolve.lesson;
    };

    $ctrl.openChapter = function (chapter) {
        chapter.open = !chapter.open;
    };

}
